<template>
  <div>
    <headerTop></headerTop>
      <div class="refundHeader">
    <div class="header">
      <img src="@/assets/images/home/AIRPLEX.png" alt="" />
      <h2>订单详情</h2>
    </div>
  </div>
    <div class="box">
      <div class="top">
      </div>
      <div class="basic">
        <div class="jiben">基本信息</div>
        <div class="basicDev">
           <!-- 基本信息左 -->
          <div class="basicDevFlex">
            <!-- 订单编号 -->
            <div>
              <span class="spanName">订单编号：</span>
              <span>{{tableData.code}}</span>
            </div>
            <div style="line-height:30px">
              <span class="spanName">订单状态：</span>
              <!-- <span v-if="tableData.state == 1 || tableData.state == 2 || tableData.state == 3 || tableData.state == 5 || tableData.state == 7 "> -->
              <span v-if="tableData.state == 1 || tableData.state == 2 || tableData.state == 3" style="color:#ff5e00">{{tableData.states}}</span>
              <span v-else-if="tableData.state == 5" style="color:#47c469">{{tableData.states}}</span>
              <span v-else-if="tableData.state == 7" style="color:#f62b4e">{{tableData.states}}</span>
              <span v-else-if="tableData.state == 16 || tableData.state == 17" style="color:#f62b4e">理赔中</span>
              <span v-else-if="tableData.state == 12" style="color:#f62b4e">理赔已撤销！</span>
              <span v-else-if="tableData.state == 13" style="color:#f62b4e">理赔已拒绝</span>
              <!-- </span> -->
              <span v-else style="color:#0077ff">{{tableData.states}}</span>
              <span
                class="btnfs"
                @click="delivery(tableData)"
                v-if="deliverGoodsStatus && role === 2 && process === 2 && tenantType===3"
              >发货</span>
              <span
                class="btnfs"
                @click="Receiving(tableData)"
                v-if="deliverGoodsStatus && role === 1 && process === 3 && isReceiver === 1"
              >收货</span>
              <!-- 是买家订单为未支付 -->
              <span
                class="btnfs"
                @click="payOrder(tableData)"
                v-if="deliverGoodsStatus && role === 1 && process === 1"
              >付款</span>
              <span
                v-if="deliverGoodsStatus && role === 1 && process === 1"
                class="btnfs"
                @click="cancellationOrder(tableData)"
              >取消订单</span>
              <!-- 买家/订单未发货 -->
              <router-link
                class="btnfs"
                rel="opener"
                target="_blank"
                :to="{
                path: '/refunddispose',
                query: { details: this.$route.query.orderId }
                }"
                v-if="deliverGoodsStatus && role === 1 && process === 2"
              >申请退款</router-link>
              <!-- 卖家发起退款 -->
              <span
                v-if="deliverGoodsStatus && role === 2 && process === 2"
                class="btnfs"
                @click="sponsortk(tableData)"
              >发起退款</span>
              <!-- 卖家处理退款申请中  -->
               <router-link
               :to="{
               path: '/refunddispose',
               query: { drawback: this.$route.query.refundId }
               }"
               class="btnfs"
               v-if="deliverGoodsStatus && role === 2 && process === 9"
              >退款处理 </router-link>
              <!-- 买家处理退款申请中 -->
                <router-link
               :to="{
               path: '/refunddispose',
               query: { drawback: this.$route.query.refundId }
               }"
               class="btnfs"
               v-if="deliverGoodsStatus && role === 1 && (refundType === 1) && tableData.state !== 5 "
              >查看详情</router-link>
                <router-link
               :to="{
               path: '/salesreturn',
               query: { drawback: this.$route.query.refundId,refundType: refundType }
               }"
               class="btnfs"
               v-if="deliverGoodsStatus && role === 1 && (refundType === 2 || refundType === 3) && tableData.state !== 5"
              >查看详情</router-link>
              <!-- 买家发起退款操作为撤销 -->
                <span
                v-if="deliverGoodsStatus && role === 1 && (process === 9 || process === 10)"
                class="btnfs"
                @click="CancellationApplication(moneyBackOrderslist)"
              >撤销申请</span>
            </div>
            <!-- 配送方式        -->
            <div>
              <span class="spanName">配送方式：</span>
              <span>{{tableData.transportType == 1 ? '物流快递':"上门自提"}}</span>
            </div>
            <!-- 订单来源 -->
            <div>
              <span class="spanName">订单来源：</span>
              <span>{{tableData.sourceAndEnquiry}}</span>
            </div>
          </div>
           <!-- 基本信息中 -->
          <div class="basicDevFlex" style="margin:0 9px">
            <div>
              <span class="spanName">交易对方：</span>
              <span v-if="role === 1">{{tableData.buyShopName}}</span>
              <span v-if="role === 2">{{tableData.createShopName}}</span>
              <xiaopei  v-if="role === 2" :oppositeTenantId="tableData.createTenantId" :orderId="tableData.id">
                <i class="iconfont icon-a-lujing162"></i>
              </xiaopei>
              <xiaopei  v-if="role === 1" :oppositeTenantId="tableData.buyTenantId" :orderId="tableData.id">
                <i class="iconfont icon-a-lujing162"></i>
              </xiaopei>
            </div>
            <div>
              <span class="spanName">提交时间：</span>
              <span>{{tableData.createTime}}</span>
            </div>
            <div>
              <span class="spanName">支付方式：</span>
              <!-- <span v-if="tableData.payType === 0">挂账</span> -->
              <span v-if="tableData.payType === 1">线下转账</span>
              <span v-else>挂账</span>
              <!-- <span v-if="tableData.payType === 2">挂账</span> -->
            </div>
            <div>
              <span class="spanName">订单类型：</span>
              <span v-if="tableData.type=== 0">普通订单</span>
              <span v-if="tableData.type=== 1">退款订单</span>
              <span v-if="tableData.type=== 2">退货订单</span>
            </div>
          </div>
           <!-- 基本信息右 -->
          <div class="basicDevFlex" >
            <div>
              <span class="spanName">支付时间：</span>
              <span>{{tableData.payDate}}</span>
            </div>

            <div class="toolDev" >
              <div class="spanName">收货地址: </div>
              <!-- <span>{{tableData3[0].receiveAddress.length}}</span> -->
                <Tooltip  class="divName"  max-width="300" placement="left-start" :content="tableData3[0].receiveAddress" >
                    <span v-if="tableData3[0].receiveAddress.length > 15" style="cursor: pointer;">{{tableData3[0].receiveAddress.substring(0,15)+'...'}}</span>
                    <span v-else style="cursor: pointer;">{{tableData3[0].receiveAddress}}</span>
                </Tooltip>
            </div>
            <!-- style="height:40px; overflow: hidden;text-overflow: ellipsis;" -->
            <div class="toolDev" >
              <div class="spanName">买家留言: </div>
                <Tooltip class="divNames"  max-width="300" placement="left-start" :content="tableData.remark" >
                    <span v-if="tableData.remark.length > 20">{{tableData.remark.substring(0,20)+'...'}}</span>
                    <span v-else>{{tableData.remark}}</span>
                </Tooltip>
            </div>
          </div>

        </div>
      </div>
      <!-- 发票信息 -->
      <div class="invoice" style="margin-top:20px" v-if="orderI != '{}'">
        <div class="jiben">发票信息</div>
        <vxe-table
          :data="tableData2"

          show-overflow
          align="center"
        >
          <vxe-column field="invoiceType" title="发票类型">
            <template v-slot="{ row }">
              <div>
                {{
                  row.invoiceType === 0 ? '增值税专用发票' : '增值税普通发票'
                }}
              </div>
            </template>
          </vxe-column>
          <vxe-column field="invoiceTitle" title="发票抬头">
            <template v-slot="{ row }">
              <div>{{row.invoiceTitleName}}</div>
            </template>
          </vxe-column>
          <vxe-column field="invoiceTaxId" title="税号"></vxe-column>
          <vxe-column field="invoiceContent" title="发票内容"></vxe-column>
        </vxe-table>
      </div>
      <!-- 收货人信息 -->
      <div class="consignee" style="margin-top:20px">
        <div class="jiben">收货人信息</div>
        <vxe-table
          :data="tableData3"
          show-overflow
          align="center"
        >
          <vxe-column field="receiveName" title="收货人"></vxe-column>
          <vxe-column field="receivePhone" title="手机号"></vxe-column>
          <vxe-column field="receiveAddress" title="收货地址"></vxe-column>
        </vxe-table>
      </div>
      <!-- 物流信息 -->
      <div v-if="logisticslist.length > 0">
        <div class="logistics" v-for="(item,index) in logisticslist" :key="index">
        <div class="jiben">物流信息</div>
        <div class="mt10 mb5 fz28px" style="margin-bottom:0">
          <span >出库单号：</span>
          <span>{{item.outCode}}</span>
        </div>
        <div style="border:1px solid #ccc;border-top:0;border-bottom:0">
        <Row style="padding-top:10px">
          <Col span="5" style="padding-left:25px">
            <div>
              <span>配送方式：</span>
              <span>{{item.shipmentType}}</span>
            </div>
          </Col>

          <Col span="6">
            <div class="w11">
              <Tooltip :content="item.logisticsCode" max-width="450">
              <span class="w11-1">单号&nbsp;:</span>
             <span class="w12">&nbsp;{{item.logisticsCode||"-"}}</span>
              </Tooltip>
            </div>
          </Col>
          <Col span="5">
            <div>
              <span>预计到货时间：</span>
              <span>{{item.arrivalTime}}</span>
            </div>
          </Col>

        </Row>
        <Row style="margin-top:10px">
            <Col span="5" style="padding-left:25px;">
              <div class="w13">
                <span>运输公司&nbsp;:</span>
                <Tooltip :content="item.transportCompany" max-width="450">
                <span class="w14">&nbsp;{{item.transportCompany}}</span>
                </Tooltip>
              </div>
            </Col>
            <Col span="6">
              <div>
                <span>联系手机&nbsp;:</span>
                <span>&nbsp;{{item.deliverPhone||'-'}}</span>
              </div>
              </Col>
            <Col span="5">
              <div>
                <span>发货日期&nbsp;:</span>
                <span>{{item.sendDate}}</span>
              </div>
            </Col>
        </Row>
        <Row>
          <Col span="23" style="padding-left:25px;margin-top:10px;padding-bottom:10px;line-height:20px">
            <div>
              <span>发货备注&nbsp;:</span>
              <span> {{item.remark}}</span>
            </div>
          </Col>
        </Row>
        </div>
        <!-- <vxe-table
          v-if="item.ordersDetailVOList.length > 0"
          :data="item.ordersDetailVOList"
          show-overflow
          align="center"
        > -->
        <!-- 会报length未定义的错，后续如果对页面有影响再注释 放开上面的代码 -->
           <vxe-table
          :data="item.ordersDetailVOList"
          show-overflow
          align="center"
        >
          <vxe-column field="receiveName" title="商品名称"  width="500">
            <template v-slot="{ row }" >
              <div class="one">
                <div class="img" v-if="row.pictureUrl" style="min-width:80px">
                  <img :src="row.pictureUrl" alt="" />
                </div>
                <div class="img" style="min-width:80px" v-else>
                  <img src="https://img.g-part.cn/prod/wss/default_null.png" alt="" />
                </div>
                <div class="one-right" >
                  <div class="one-right-top" style="max-weith:300px">
                    <span v-if="row.qualityType" class="ycj">{{row.qualityType}}</span>
                    <span class="brandmc">{{ row.partName }}</span>
                  </div>
                  <div class="one-right-bottom" style="text-algin:center">
                    <div v-show="row.genuineGuarantee"  style="display:inline-block;margin-right:20px" class="mr5">
                      <span class="iconfont icon-a-lujing153"></span>
                      <span>正品保证</span>
                    </div>
                    <div v-show="row.technicalSupport"  style="display:inline-block;margin-right:20px" class="mr5">
                      <span class="iconfont icon-a-ziyuan5"></span>
                      <span>技术支持</span>
                    </div>
                    <br>
                    <div v-show="row.warrantyService"  style="display:inline-block;margin-right:20px" class="mr5">
                      <span class="iconfont icon-a-ziyuan4"></span>
                      <span>保修服务</span>
                    </div>
                    <div v-show="row.returnPromise"  style="display:inline-block;margin-right:20px" class="mr5">
                      <span class="iconfont icon-a-ziyuan4"></span>
                      <span>退换货承诺</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </vxe-column>
          <vxe-column field="quantityShipped" title="发货数量"></vxe-column>
          <vxe-column field="storeName" title="发货仓库"></vxe-column>
        </vxe-table>
        </div>
      </div>
      <!-- 商品信息 -->
      <div class="consignee" style="margin-top:20px">
        <div class="jiben">商品信息</div>
        <vxe-table :data="tableData4"  align="center">
          <vxe-column field="partName" title="商品名称" width="500">
            <template v-slot="{ row }">
              <div class="one">
                <div class="img" v-if="row.pictureUrl">
                  <img :src="row.pictureUrl" alt="" />
                </div>
                <div class="img" v-else>
                  <img  src="https://img.g-part.cn/prod/wss/default_null.png" alt="" />
                </div>
                <div class="one-right" >
                  <div class="one-right-top">
                    <span v-if="row.qualityType" class="ycj">{{row.qualityType}}</span>
                    <span>{{ row.partName }}</span>
                  </div>
                  <div class="one-right-bottom">
                    <div v-show="row.genuineGuarantee"  style="display:inline-block;margin-right:20px" class="mr5">
                      <span class="iconfont icon-a-lujing153"></span>
                      <!-- <span>正品保证</span> -->
                    </div>
                    <div v-show="row.technicalSupport"  style="display:inline-block;margin-right:20px" class="mr5">
                      <span class="iconfont icon-a-ziyuan5"></span>
                      <!-- <span>技术支持</span> -->
                    </div>
                    <div v-show="row.warrantyService"  style="display:inline-block;margin-right:20px"  class="mr5">
                      <span class="iconfont icon-a-ziyuan4"></span>
                      <!-- <span>保修服务</span> -->
                    </div>
                    <div v-show="row.returnPromise"  style="display:inline-block;margin-right:20px" class="mr5">
                      <span class="iconfont icon-a-ziyuan4"></span>
                      <!-- <span>退换货承诺</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </vxe-column>
          <vxe-column field="partNum" title="购买数量"></vxe-column>
          <vxe-column field="provinceCity" title="发货地">
             <template v-slot="{ row }">
              <span>{{ row.shipCity }}{{ row.shipStore }}</span>
            </template>
          </vxe-column>
          <vxe-column field="price" title="单价">
            <template v-slot="{ row }">
              <span>{{ row.price }}</span>
            </template>
          </vxe-column>
          <vxe-column field="money" title="小计">
            <template v-slot="{ row }">
              <span class="money" v-if="row.money">
                <span class="￥">￥</span>{{ row.money }}</span
              >
            </template>
          </vxe-column>
        </vxe-table>
        <!-- <div class="productTableHeader">
          <div style="width:500px;">商品名称</div>
          <div style="width:150px;">数量</div>
          <div style="width:200px;">发货地</div>
          <div style="width:150px;">单价</div>
          <div style="width:198px;">小计</div>
        </div> -->
        <!-- <div class="productTableBody" v-for="(item,index) in tableData4" :key="index">
          <div style="width:80px;height:80px;margin-top:10px;margin-left:10px;display: inline-block;">
            <img style="height:100%;width:100%;vertical-align: -100%;" v-if="item.pictureUrl" :src="item.pictureUrl" alt="" />
            <img style="height:100%;width:100%;vertical-align: -100%;" v-else src="https://img.g-part.cn/prod/wss/default_null.png" alt="" />
          </div>
          <div class="divSG" style="width:410px;">
            <div >
              <span v-if="item.qualityType" class="ycj">{{item.qualityType}}</span>
              <span>{{ item.partName }}</span>
            </div>
            <div>
              <span class="iconfont icon-a-lujing153"></span>
              <span>正品保证</span>
              <span class="iconfont icon-a-ziyuan5"></span>
              <span>正品保证</span>
              <span class="iconfont icon-a-ziyuan4"></span>
              <span>正品保证</span>
            </div>
          </div>
          <div class="divSG" style="width:150px;line-height:110px;height:110px">
            {{item.partNum}}
          </div>
          <div class="divSG" style="width:200px;line-height:110px;height:110px">
            {{item.provinceCity}}
          </div>撤销申请btnfs
          <div class="divSG" style="width:150px;line-height:110px;height:110px">
            {{item.price}}
          </div>
          <div class="divSG" style="width:198px;line-height:110px;height:110px;font-size: 18px;
color: #F62B4E;">
            {{'￥'+item.money}}
          </div>
        </div> -->
      </div>
      <!-- 退款信息 -->
      <div class="returnGoods" v-if="tableData5.length > 0">
        <div class="jiben">退款信息</div>
        <div v-for="(item, index) in tableData5" :key="index" style="border:1px solid #E2E2E2;border-bottom:none">
          <div style="margin-top: 10px;padding-left:25px">
            <span  style="margin-right: 40px;width:300px;display: inline-block;">订单号：{{ item.code }}</span>
            <span style="margin-right: 30px"
              >申请时间：{{ item.createTime }}</span
            >
            <span style="color: #0074ff" v-if="item.state === 1">待付款</span>
            <span style="color: #0074ff" v-if="item.state === 2">待发货</span>
            <span style="color: #0074ff" v-if="item.state === 3">待收货</span>
            <span style="color: #0074ff" v-if="item.state === 5">已完成</span>
            <span style="color: #0074ff" v-if="item.state === 6">已取消</span>
            <span style="color: #0074ff" v-if="item.state === 7">异常</span>
            <span style="color: #0074ff" v-if="item.state === 8">已确认运费</span>
            <span style="color: #0074ff" v-if="item.state === 9">退款申请中</span>
            <span style="color: #0074ff" v-if="item.state === 10">退货申请中</span>
            <span style="color: #0074ff" v-if="item.state === 11">交易关闭</span>
            <span style="color: #0074ff" v-if="item.state === 12">已撤销</span>
            <span style="color: #0074ff" v-if="item.state === 13">已拒绝</span>
             <!-- <router-link
               v-if="item.state != 0 "
               rel="opener"
               :to="{
                 path: '/refunddispose',
                 query: { drawback: item.id }
               }"
               class="sq"
              >查看申请</router-link> -->
            <!-- 卖家发起退款 -->
            <router-link
               v-if="item.state != 0 && item.subType == 2"
               rel="opener"
               :to="{
                 path: '/saleshandlereturn',
                 query: { drawback: item.id }
               }"
               class="sq"
              >查看详情</router-link>
              <!-- 买家发起退款 -->
              <router-link
               v-if="item.state != 0 && item.subType == 1 && item.type == 1"
               rel="opener"
               :to="{
                 path: '/refunddispose',
                 query: { drawback: item.id }
               }"
               class="sq"
              >查看详情</router-link>
              <!-- 买家售后中发起的退款 -->
              <router-link
               v-if="item.state != 0 && item.subType == 1 && item.type == 3"
               rel="opener"
               :to="{
                 path: '/salesreturn',
                 query: { drawback: item.id, refundType: item.type }
               }"
               class="sq"
              >查看详情</router-link>
            <span class="sq" v-if="(item.state === 9 && role === 1) || (item.state === 10 && role === 1)"
            @click="CancellationApplication(item)"
              >撤销申请</span
            >
          </div>
          <div class="refundClass">
            <span style="margin-right: 40px;display: inline-block;width:300px"
              >申请人：{{ item.createUname }}</span
            >
          </div>
          <!-- <div class="refundClass" style="margin-right: 30px">
            审批人：{{ item.buyShopName }}
          </div> -->
          <div style=" display: inline-block;">审批时间：{{ item.auditDate }}</div>

          <div class="refundTable">
            <div class="tableTop">
              <span style="width: 500px">商品名称</span>
              <span style="width: 130px">退款数量</span>
              <span style="width: 130px">发货地</span>
              <span style="width: 130px">退款单价</span>
              <span style="width: 130px">小计</span>
              <!-- <span style="width: 130px">申请人</span> -->
            </div>
            <div
              class="tablemind"
              v-for="(itemChildren, index) in item.children"
              :key="index"
            >
              <div style="width: 100px">
                <div class="imgs" v-if="itemChildren.pictureUrl">
                  <img :src="itemChildren.pictureUrl" alt="" />
                </div>
                <div class="imgs" v-else>
                  <img src="https://img.g-part.cn/prod/wss/default_null.png" alt="" />
                </div>
              </div>
              <div style="width: 395px;text-align: left;" class="w22 w33">
                <span class="ycj">{{itemChildren.qualityType}}</span>
                <!-- <div> -->
                <p style="max-width:308px;display:inline-block;">{{ itemChildren.partName }}</p>
                <!-- </div> -->
              </div>
              <div style="width: 130px" class="w22">
                {{ itemChildren.moneybackNum }}
              </div>
               <div style="width: 130px" class="w22">
                {{ itemChildren.shipCity }}
                {{ itemChildren.shipStore }}
              </div>
              <div style="width: 130px" class="w22">
                {{ itemChildren.price }}
              </div>
              <div style="width: 130px" class="w22">
                {{ itemChildren.moneybackPrice }}
              </div>
              <!-- <div style="width: 130px">
                {{ itemChildren.createUname }}
              </div> -->
            </div>
             </div>
          </div>
        </div>
      <!-- 退货信息 -->
      <div class="returnGoods" v-if="tableData7.length > 0">
        <div class="jiben">退货信息</div>
        <div v-for="(item, index) in tableData7" :key="index" style="border:1px solid #E2E2E2">
          <div style="margin-top: 10px;padding-left:20px">
            <span style="margin-right: 40px;width:300px;display: inline-block;">订单号：{{ item.code }}</span>
            <span style="margin-right: 30px"
              >申请时间：{{ item.createTime }}</span
            >
            <span style="color: #0074ff" v-if="item.state === 1">待付款</span>
            <span style="color: #0074ff" v-if="item.state === 2">待发货</span>
            <span style="color: #0074ff" v-if="item.state === 3">待收货</span>
            <span style="color: #0074ff" v-if="item.state === 5">已完成</span>
            <span style="color: #0074ff" v-if="item.state === 6">已取消</span>
            <span style="color: #0074ff" v-if="item.state === 7">异常</span>
            <span style="color: #0074ff" v-if="item.state === 8">已确认运费</span>
            <span style="color: #0074ff" v-if="item.state === 9">退款申请中</span>
            <span style="color: #0074ff" v-if="item.state === 10">退货申请中</span>
            <span style="color: #0074ff" v-if="item.state === 11">交易关闭</span>
            <span style="color: #0074ff" v-if="item.state === 12">已撤销</span>
            <span style="color: #0074ff" v-if="item.state === 13">已拒绝</span>
            <router-link
             v-if="item.state !== 0 && item.type == 2"
               rel="opener"
               target="_blank"
               :to="{
                 path: '/salesreturn',
                 query: { drawback: item.id , refundType: item.type }
               }"
               class="sq"
              >查看详情</router-link>
            <span class="sq" v-if="(item.state === 9 && role === 1) || (item.state === 10 && role === 1)"
            @click="cxapplication(item)"
              >撤销申请</span
            >
          </div>
          <div class="refundClass" style="padding-left:20px">
            <span style="margin-right: 40px;width:300px;display: inline-block;"
              >申请人：{{ item.createUname }}</span
            >
          </div> 
          <!-- =========1111 -->
          <!-- <div class="refundClass" style="margin-right: 30px">
            审批人：{{ item.buyShopName }}
          </div> -->
          <!-- =============22222 -->
           <div  style=" display: inline-block;">审批时间：{{ item.auditDate }}</div>
<!-- =============111 -->
          <div class="refundTable">
            <div class="tableTop">
              <span style="width: 500px">商品名称</span>
              <span style="width: 130px">退款数量</span>
              <span style="width: 130px">发货地</span>
              <span style="width: 130px">退款单价</span>
              <span style="width: 130px">小计</span>
              <!-- <span style="width: 150px">申请人</span> -->
            </div>
            <div
              class="tablemind"
              v-for="(itemChildren, index) in item.children"
              :key="index"
            >
              <div style="width: 100px">
                <div class="imgs" v-if="itemChildren.pictureUrl">
                  <img :src="itemChildren.pictureUrl" alt="" />
                </div>
                <div class="imgs" v-else>
                  <img src="https://img.g-part.cn/prod/wss/default_null.png" alt="" />
                </div>
              </div>
              <div style="width: 395px;text-align: left;" class="w22 w33">
                <span class="ycj" v-if="itemChildren.qualityType">{{itemChildren.qualityType}}</span>
                <p style="max-width:308px;display:inline-block;">{{ itemChildren.partName }}</p>
              </div>
              <div style="width: 130px" class="w22">
                {{ itemChildren.refundNum }}
              </div>
              <div style="width: 130px" class="w22">
                {{ itemChildren.shipCity }}
                {{ itemChildren.shipStore }}
              </div>
              <div style="width: 130px" class="w22">
                {{ itemChildren.price }}
              </div>
              <div style="width: 130px;color: red;font-weight: bold;font-size: 18px;" class="w22" v-if="itemChildren.refundAmount">
                ￥{{ itemChildren.refundAmount }}
              </div>
              <!-- <div style="width: 130px" class="w22">
                {{ itemChildren.createUname }}
              </div> -->

            </div>
          </div>
        <!-- ==================222 -->
        </div>
      </div>
      <!-- 理赔信息 -->
      <div class="returnGoods" v-if="tableData8.length > 0">
        <div class="jiben">理赔信息</div>
        <div v-for="(item, index) in tableData8" :key="index" style="border:1px solid #E2E2E2">
          <div style="margin-top: 10px;padding-left:20px">
            <span style="margin-right: 40px;width:300px;display: inline-block;">订单号：{{ item.code }}</span>
            <span style="margin-right: 30px"
              >申请时间：{{ item.createTime }}</span
            >
            <span style="margin: 0 35px;color:#377CF1" v-if="item.state === 13">已拒绝</span>
            <span v-else-if="item.state === 12" style="margin: 0 35px">已撤销</span>
            <span v-else-if="item.state === 16 || item.state === 17">
              <span style="margin: 0 35px;color:#377CF1">理赔中</span>
              <Button v-if="role === 1 && !item.children[0].claimManageStatus" type="primary"  @click = "confirm(item)" style="margin-right: 20px">撤销理赔</Button>
            </span>
            <span style="margin: 0 35px;color:#377CF1" v-else-if="item.state === 5">已完成</span>
            <router-link
              rel="opener"
              target="_blank"
              :to="{
                path: role === 1?'/claim':'/claimSolid',
                query: { ordersId: orderBasic.id, ordersDetailId:item.children[0].id,code:item.children[0].ordersCode,type:1 }
              }"
              class="route"
              >{{item.state === 16 || item.state === 17?'查看理赔':'查看详情'}}</router-link
            >
          </div>
          <div class="refundClass" style="padding-left:20px">
            <span style="margin-right: 40px;width:300px;display: inline-block;"
              >申请人：{{ item.createUname }}</span
            >
          </div> 
          <div  style=" display: inline-block;">审批时间：{{ item.auditDate }}</div>
          <div class="refundTable">
            <div class="tableTop">
              <span style="width: 500px">商品名称</span>
              <span style="width: 130px">理赔数量</span>
              <span style="width: 130px">理赔原因</span>
              <span style="width: 130px">处理方式</span>
            </div>
            <div
              class="tablemind"
              v-for="(itemChildren, index) in item.children"
              :key="index"
            >
              <div style="width: 100px">
                <div class="imgs" v-if="itemChildren.pictureUrl">
                  <img :src="itemChildren.pictureUrl" alt="" />
                </div>
                <div class="imgs" v-else>
                  <img src="https://img.g-part.cn/prod/wss/default_null.png" alt="" />
                </div>
              </div>
              <div style="width: 395px;text-align: left;" class="w22 w33">
                <span v-if="itemChildren.qualityType" class="ycj">{{ itemChildren.qualityType }}</span>
                <span v-else class="ycj">{{itemChildren.qualityType}}</span>
                <span> {{ itemChildren.partName }}</span>
              </div>
              <div style="width: 130px" class="w22">
                {{ itemChildren.refundNum }}
              </div>
              <div style="width: 130px" class="w22">
                {{ itemChildren.claimCause }}
              </div>
              <div style="width: 130px" class="w22">
                <span v-if="itemChildren.claimManageStatus">{{claimReviceList[itemChildren.claimManageMode]}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom:20px">
        <div class="jiben">操作信息</div>
        <div style="border:1px solid #E2E2E2">
          <ul style="margin-top:10px;margin-left:10px">
            <li v-for="(item, index) in tableData6" :key="index">
              <!-- <span style="margin-right: 10px">{{ item.accountName }}</span> -->
              <span style="margin-right: 10px;font-size:14px">{{ item.eventTime }}</span>
              <span style="font-size:14px">{{ item.event }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 物流信息 -->
      <Modal
        v-model="logistics1"
        title="物流信息"
        :mask-closable="false"
        :closable="false"
        footer-hide
        >
       <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
           <FormItem label="配送方式:" prop="transportType">
               <Select v-model="formValidate.transportType">
                   <Option v-for="item in deliverylist" :key="item.id" :value="item.id">{{item.name}}</Option>
               </Select>
           </FormItem>
           <FormItem label="运输公司:" prop="transportCompany">
               <Input v-model="formValidate.transportCompany" type="textarea" :autosize="{minRows: 2, maxRows: 3}" maxlength="50" show-word-limit></Input>
           </FormItem>
           <FormItem label="单号:" prop="logisticsCode">
               <Input v-model="formValidate.logisticsCode" type="textarea" :autosize="{minRows: 2,maxRows: 3}" maxlength="50" show-word-limit></Input>
           </FormItem>
           <FormItem label="联系手机:" prop="deliverPhone">
               <Input v-model="formValidate.deliverPhone"></Input>
           </FormItem>
           <FormItem label="预计到货时间:" prop="arrivalTime">
              <DatePicker type="date" @on-change="time1" v-model="formValidate.arrivalTime" :options="options3"></DatePicker>
           </FormItem>
           <FormItem label="发货备注" prop="remark">
               <Input v-model="formValidate.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" maxlength="100" show-word-limit></Input>
           </FormItem>
           <FormItem>
               <Button type="error" :loading="dogood" class="btn mr50" @click="handleSubmit('formValidate')">确定发货</Button>
               <Button type="error" class="btn" @click="handleReset('formValidate')" style="margin-left:8px">取消</Button>
           </FormItem>
       </Form>
    </Modal>
    <!-- 取消订单 -->
        <Modal
      v-model="modal2"
      width="360"
      :closable="false"
      @on-visible-change="visible"
    >
      <div style="text-align: center">
        <div style="margin-bottom: 20px">
          <span> 您确认要取消订单么？取消订单后，不能恢复。</span>
        </div>
        取消原因：
        <Select v-model="cancel" label-in-value style="width: 200px" @on-change="cancelChange">
          <Option
            v-for="item in cancellation"
            :value="item.id"
            :key="item.id"
            >{{ item.itemName }}</Option
          >
        </Select>
      </div>
      <div slot="footer">
        <Button
          size="small"
          type="primary"
          class="yes"
          style="margin-right: 40px"
          @click="cancellationOK"
          >确定</Button
        >
        <Button
          size="small"
          type="primary"
          class="yes"
          style="margin-right: 70px"
          @click="modal2 = false"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import headerTop from '@/views/base/common/header-top.vue'
// import { awaken } from '@/api/xiaopei/shout.js'
import xiaopei from '@/views/xiaopei/index.vue'
import { getDate } from '@/libs/tools.js'
import {
  getOrderDetail,
  orderDelivery,
  orderTakeDelivery,
  getlogisticsdata
} from '@/api/orderDetails/orderDetails.js'

import { revoke,buyerfreight,getDictionariesItemList,cancelOrder,applyForRefund } from '@/api/business/bought.js'
import {getshipments} from '@/api/business/sold.js'
import { handleCliam } from '@/api/myweb/cliam'
export default {
  // mixins: [awaken],
  components: {
    headerTop,
    xiaopei
  },
  data() {
    return {
      // isSellerRefunded:'',
      claimReviceList: ['','收到原货','收到换货','收到退货','已经销毁'],
      moneyBackOrderslist:{}, // 基本信息缺少操作按钮(撤销申请)
      cancel: '',
      cancelStatus: '',
      cancellation: [], // 取消弹框下拉数据
      modal2: false, // 取消订单弹框
      logisticslist:[], // 物流数据
      logisticsid:{}, //物流id
      logistics1: false, // 物流信息
      shipments:'', // 发货
      dogood:false, // 转圈
      orderI: '',
      role: null,
      tenantType: JSON.parse(localStorage.getItem('userdetails_tenantInfo'))
        .tenantType,
      productTime: '', // 拍下时间
      paymentTime: '', // 付款时间
      deliveryTime: '', // 发货时间
      receivingTime: '', // 收货时间
      completeTime: '', // 完成时间
      tableData: {},
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      tableData6: [],
      tableData7: [],
      tableData8: [],
      orderInvoiceLength: 0,
      deliverGoodsStatus: true,
      process: null,
      isReceiver:'',
      refundType:'',
        // 表单
      formValidate: {
          transportType: '', // 方式
          transportCompany: '', // 运输公司
          logisticsCode: '', // 单号
          deliverPhone: '', // 联系手机
          arrivalTime: '', //到货时间
          remark : '', //备注
      },
      // 规则
      ruleValidate: {
        transportType: [
            { required: true, message: '请选择配送方式', trigger: 'change' }
        ],
        transportCompany: [
            { required: true, message: '请输入运输公司', trigger: 'blur' },
        ],
        logisticsCode: [
            { required: true, message: '请输入单号', trigger: 'blur' }
        ],
        deliverPhone:[
            {
            pattern: /^((13[0-9])|(14[5-9])|(15[0-3,5-9])|(16[5-7])|(17[0-9])|(18[0-9])|19([0,1,3,5,8,9]))\d{8}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
      },
      deliverylist:[
       {
        id:'0',
        name:'物流'
       },
       {
        id:'1',
        name:'快递'
       },
       {
        id:'2',
        name:'自配'
       },
       {
        id:'3',
        name:'自提'
       }
      ], // 配送方式
      options3: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
    }
  },
  created() {
    this.tableList()
    this.logisticsxq()
    this.getDictionariesItemList()
  },
  methods: {
    async tableList() {
      this.tableData ={}
      this.tableData3 =[]
      this.tableData2 =[]
      let params = {}
      params.id = this.$route.query.id
      let res = await getOrderDetail(params)
      if (res.status) {
        switch (res.data.orderBasic.state) {
          case 1:
            res.data.orderBasic.states = '待付款'
            break
          case 2:
            res.data.orderBasic.states = '待发货'
            break
          case 3:
            res.data.orderBasic.states = '待收货'
            break
          // case 4:
          //   res.data.orderBasic.states = '已完成'
          //   break
          case 5:
            res.data.orderBasic.states = '已完成'
            break
          case 6:
            res.data.orderBasic.states = '已取消'
            break
          case 7:
            res.data.orderBasic.statestableDatatransportType = '异常'
            break
          case 8:
            res.data.orderBasic.states = '已确认运费'
            break
          case 9:
            res.data.orderBasic.states = '退款申请中'
            break
          case 10:
            res.data.orderBasic.states = '退货(并退款)申请中'
            break
          case 11:
            res.data.orderBasic.states = '交易关闭'
            break
          case 14:
            res.data.orderBasic.states = '仓库处理中'
          break

        }
        this.tableData =res.data.orderBasic
        this.process = res.data.orderBasic.state
        this.isReceiver = res.data.orderBasic.isReceiver
        this.refundType = res.data.orderBasic.refundType
        this.orderBasic = res.data.orderBasic
        this.buyShopId = res.data.buyShopId
        res.data.orderConsignee.receiveAddress = res.data.orderConsignee.receiveAddress == null ? ' ':res.data.orderConsignee.receiveAddress
        this.tableData3.push(res.data.orderConsignee)
        // this.orderInvoiceLength = res.data.orderInvoice.length
        this.tableData2.push(res.data.orderInvoice?res.data.orderInvoice:[])
        this.orderI = JSON.stringify(res.data.orderInvoice)

        this.tableData4 = res.data.ordersDetail
        this.tableData5 = res.data.moneyBackOrders
        // if(this.tableData5.length > 0){
        // this.moneyBackOrderslist.id = this.tableData5[0].id
        this.moneyBackOrderslist.id = this.$route.query.refundId
        
        console.log(this.tableData5);
        console.log(this.moneyBackOrderslist);
        // }

        console.log(this.tableData5,'this.tableData5');
        this.tableData6 = res.data.ordersLog
        this.tableData7 = res.data.refundOrders
        this.tableData8 = res.data.claimOrders
        this.role = res.data.role
        // this.isSellerRefunded = res.data.isSellerRefunded // 区分买卖双方发起的退款申请
        // console.log(this.isSellerRefunded);
        this.productTime = res.data.orderDate.createTime
        this.paymentTime = res.data.orderDate.payDate
        this.deliveryTime = res.data.orderDate.sendDate
        this.receivingTime = res.data.orderDate.confirmDate
        this.completeTime = res.data.orderDate.finishTime
      }
    },
    expandVisibleMethod({ row }) {
      return false
    },
    // 买家付款按钮
    payOrder(val){
      console.log(val);
      this.$router.push({
        path: '/payOrder',
        query: { ordeNumber: JSON.stringify(this.$route.query.orderId.split(',')) }
      })
    },
    // 买家取消按钮
    cancellationOrder(row) {
      this.modal2 = true
      this.ordersCode = row.id
    },
   // 数据字典接口(取消原因)
    async getDictionariesItemList() {
      let params = {}
      params.dictCode = 'QXYY'
      let res = await getDictionariesItemList(params)
      if (res.code === 0) {
        this.cancellation = res.data.records
      }
    },
    // 取消原因变化事件
    cancelChange(val) {
      if(val){
      this.cancelStatus = val.label
      }
    },
    visible() {
      this.cancel = ''
    },
    // 买家取消按钮发送请求
    cancellationOK() {
      this.$Modal.confirm({
        title: '是否要取消订单',
        onOk: async () => {
          this.spinShow = true
          let params = {}
          params.cancelReason = this.cancelStatus
          params.orderId = this.ordersCode
          if(this.cancelStatus === ''){
            this.$Message.error('请填写取消原因')
            return
          }
          let res = await cancelOrder(params)
          if (res.status) {
            this.$Message.success('成功取消')
            this.modal2 = false
            this.tableList()
          }
          this.cancel = ''
        },
        onCancel: () => {
          this.$Message.warning('已取消')
        }
      })
    },
    // 卖家发起退款
     async sponsortk(row){
      console.log(row);
      console.log('发起退款');
       let res = await applyForRefund(row.id)
       if(res.status){
          this.$router.push({
        path:'/saleshandlereturn',
        query:{details: row.id}
      })
      }
    },
    // 物流
    async logisticsxq(){
      if(this.$route.query.orderId){
      this.logisticsid.orderId = this.$route.query.orderId
      }else{
      this.logisticsid.orderId = this.$route.query.id.substr(1)
      }
      // this.logisticsid.orderId = '1514907109807984642'
      const res =await getlogisticsdata(this.logisticsid.orderId)
      if(res.status){
        this.logisticslist = res.data.list
        console.log(this.logisticslist,'this.logisticslist');
      }
    },
    // 发货
    async delivery(row) {
      this.logistics1=true
      this.shipments=row.id
      // let params = {}
      // params.orderId = row.id
      // let res = await orderDelivery(params)
      // if (res.status) {
      //   this.deliverGoodsStatus = false
      //   this.tableList()
      //   this.$Message.success('已发货')
      // }
    },
    // 到货时间
    time1(a){
      console.log(a);
    },
    // 确定
    handleSubmit (name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.dogood=true
            let data=JSON.parse(JSON.stringify(this.formValidate))
            if (data.arrivalTime) {
              data.arrivalTime = getDate(
              data.arrivalTime
             )
            }
            data.orderId=this.shipments
            console.log(data);
            const res = await getshipments(data)
            console.log(res);
            this.dogood=false
            if(res.status){
              this.tableList(2)
              this.logisticsxq()
              this.$Message.success('已发货')
              this.logistics1=false
              this.$refs[name].resetFields();
            }
        } else {
          this.$Message.destroy()
          this.$Message.error('请检查表单字段!');
        }
      })
    },
    // 取消
    handleReset (name) {
      this.$refs[name].resetFields();
      this.logistics1=false
    },
    // 收货
    async Receiving(row) {
      let params = {}
      params.orderId = row.id
      let res = await orderTakeDelivery(params)
      if (res.status) {
        this.deliverGoodsStatus = false
        this.tableList()
        this.$Message.success('已收货')
      }
    },
    // 查看申请
    seeApplication(a) {
      this.$router.push({
        path: '/refunddispose',
        query: { drawback: a.id }
      })
    },
    // 撤销退货申请
    cxapplication(row){
      console.log(row);
       this.$Modal.confirm({
        title: '是否要撤销申请？',
        onOk: async () => {
          let res = await buyerfreight(row.id + '/' + row.type)
          if (res.status) {
            this.$Message.success('撤销成功')
            this.tableList(2)
          }
        },
        onCancel: () => {
          this.$Message.warning('已取消')
        }
      })
    },
    // 撤销申请
    CancellationApplication(row){
      console.log(row);
      console.log(this.moneyBackOrderslist);
     this.$Modal.confirm({
        title: '是否要撤销申请？',
        onOk: async () => {
          let res = await revoke(row.id + '/' + this.refundType)
          if (res.status) {
            this.$Message.success('撤销成功')
            this.tableList(2)
          }
        },
        onCancel: () => {
          this.$Message.warning('已取消')
        }
      })
    },
    // 撤销理赔
    confirm(val) {
      this.$Modal.confirm({
        title: '是否要撤销申请？',
        onOk: async() => {
          let data = {
            ordersId: this.orderBasic.id,
            claimDetailId: val.children[0].id,
            claimOrdersCode: val.children[0].ordersCode,
            type: 3
          }
          let res = await handleCliam(data)
          if(res.status){
            this.$Message.success('理赔已撤销！')
            location.reload() 
          }
        },
        onCancel: () => {}
      })
    }  
  }
}
</script>

<style lang="less" scoped>
.box {
width: 1030px;
  margin: 0 auto;
  overflow: hidden;
  /deep/ .w11{
 .ivu-tooltip{
    .ivu-tooltip-rel{
      display: flex;
      // .w11-1{
      //   // line-height: 26px;
      //   padding-bottom: 3px;
      // }
   .w12{
    max-width: 203px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    white-space: nowrap;
    cursor: pointer;
  }
    }

    }

  }
    /deep/ .w13{
       .ivu-tooltip{
    .ivu-tooltip-rel{
      display: flex;
  .w14{
    max-width: 109px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    white-space: nowrap;
    cursor: pointer;
 }
 }
 }
  }
  // .top {
  //   margin-top: 40px;
  //   background-color: white;
  //   width: 1200px;
  //   height: 300px;
  //   border: 1px solid #ccc;
  //   .imgMenu{
  //     height: 50px;
  //     width: 50px;
  //     img{
  //       width:100%;
  //       height: 100%;
  //     }
  //   }
  //   // .top-left {
  //   //   display: inline-block;
  //   //   width: 171px;
  //   //   height: 55px;
  //   //   vertical-align:bottom;
  //   //   margin-top: 10px;
  //   //   margin-bottom: 10px;
  //   //   img {
  //   //     width: 100%;
  //   //     height: 100%;
  //   //     vertical-align:bottom;
  //   //   }
  //   // }
  //   // .top-right {
  //   //   display: inline-block;
  //   //   margin-left: 900px;
  //   //   vertical-align:bottom;
  //   // }
  // }

  // .flexTop {
  //   // position: fixed;
  //   width: 1200px;
  //   height: 226px;
  //   // border: 1px solid #e2e2e2;
  //   border-radius: 0px;
  //   margin-bottom:20px;
  //   background-color: red;
  //   .lc {
  //     margin-top: 30px;
  //     text-align: center;
  //     height: 100px;
  //     line-height: 100px;
  //     width: 1200px;
  //     .di {
  //       vertical-align: top;
  //       width: 120px;
  //       height: 172px;
  //       display: inline-block;
  //       .iconfont {
  //         font-size: 50px;
  //       }
  //     }
  //     img {
  //       margin-bottom: 70px;
  //       vertical-align: bottom;
  //       margin-right: 20px;
  //       margin-left: 20px;
  //     }
  //   }
  // }
  .btnfs{
    border-radius: 2px;
    cursor: pointer;
    width: 58px;
    font-size: 12px;
    // height: 28px;
    line-height: 28px;
    display: inline-block;
    color: #ffffff;
    background-color: #0077ff;
    margin-left: 11px;
    text-align: center;
  }
  .basic {
    margin-top: 20px;
    .btn {
      width: 50px;
      height: 28px;
      color: white;
      text-align: center;
      line-height: 28px;
      margin-left: 20px;
      background: #0077ff;
      opacity: 1;
      border-radius: 2px;
    }
    .icon-a-lujing162 {
      margin-left: 5px;
      color: #0077ff;
    }
  }
  .logistics{
    .one {
      width: 450px;
      height: 130px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .img {
        display: inline-block;
        flex: 1;
        width: 82px;
        height: 81px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .one-right {
        padding-left: 20px;
        flex: 5;
        text-align: left;
      .one-right-top {
          display: inline-block;
      }
      .one-right-bottom {
        margin-top: 10px;
          span {
            display: inline-block;
            margin: 0 2px;
          }
        }
      }
    }
  }
  /deep/.vxe-cell{
    max-height: 100% !important;
  }
  .consignee {
    .one {
      width: 400px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .img {
        display: inline-block;
        width: 82px;
        flex: 2;
        height: 81px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .one-right {
        flex: 7;
        text-align: left;
        margin-left: 20px;
        .one-right-top {
          display: inline-block;
        }
        .one-right-bottom {
          margin-top: 10px;
          span {
            display: inline-block;
            margin: 0 2px;
          }
        }
      }
    }
    .￥ {
      color: red;
    }
    .money {
      color: red;
      font-weight: bold;
      font-size: 18px;
    }
  }
  .returnGoods {
    margin-top: 20px;
    .one {
      width: 400px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .img {
        display: inline-block;
        width: 82px;
        height: 81px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .one-right {
        .one-right-top {
          display: inline-block;
        }
        .one-right-bottom {
          margin-top: 10px;
          span {
            display: inline-block;
            margin: 0 2px;
          }
        }
      }
    }
    .tow {
      .zhuangtai {
        text-align: left;
        .btnck {
          display: inline-block;
          width: 80px;
          height: 28px;
          background: #e90d0d;
          opacity: 1;
          border-radius: 2px;
          text-align: center;
          line-height: 28px;
          color: white;
          margin-left: 10px;
        }
        .zt-one {
          margin-left: 50px;
        }
      }
      .sqr {
        text-align: left;
      }
      .sqsj {
        text-align: left;
      }
    }
    .￥ {
      color: red;
    }
    .money {
      color: red;
      font-weight: bold;
      font-size: 18px;
    }
  }
  .brandxq{
    font-size: 12px;
    padding: 2px;
    color: #ffffff;
    background-color: #47c460 !important;
  }
  .brandmc{
   display: inline-block;
    white-space: pre-wrap;
  }
  .mr5{
    margin-right: 5px;
  }
  .jiben {
    width: 1200px;
    height: 40px;
    opacity: 1;
    line-height: 40px;
    font-size: 16px;
    font-weight: 700;
  }
  .asd {
    font-size: 100px;
    color: red;
  }
  .lct {
    color: #35b94f;
  }
  .sizeClass {
    font-size: 50px;
  }
  ul {
    font-size: 12px;
    li {
      margin-top: 10px;
      font-size: 12px;
      font-weight: 400;
      span {
        font-size: 12px;
      }
    }
  }
  .subtotal {
    color: #e90d0d;
    font-weight: bold;
    font-size: 18px;
  }
  .icon-a-lujing153 {
    color: #47c460;
  }
  .icon-a-ziyuan5 {
    color: #ff8a24;
  }
  .icon-a-ziyuan4 {
    color: #24b4ff;
  }
  .refundClass {
    display: inline-block;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-left: 25px;
  }
  .refundTable {
    // width: 1200px;
    height: auto;
    border-bottom: 1px solid #ccc;
  }
  .tableTop {
    height: 40px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    background-color: #F6F6F6;
    font-weight: 700;
    font-size: 14px;
    span {
      display: inline-block;
      line-height: 40px;
      text-align: center;
    }
  }
  .tablemind {
    padding: 13px 0;
  // padding: 20px;
    height: 126px;
    // line-height: 140px;
    border-bottom: 1px solid #ccc;
    display: flex;
    // flex-direction:column;
    .imgs{
      padding-top: 11px;
      width: 84px;
    }
    img {
      width: 100%;
      height: 100%;
      // display: inline-block;
      vertical-align: top;
    }
    div {
    // vertical-align: middle;
    padding-left: 10px;
    // padding-right: 10px;
      display: inline-block;
      // text-align: center;
      // line-height: 100px;
      .imgs{
        padding-left: 0;
      }
      // span{
      //   display: inline-block;
      //   line-height: height ;
      // }
    }
    .w33{
      display: flex;
    }
    .w22{
      padding-top: 25px;

      text-align: center;
      .ycj{
        margin-top: 4px;
      }
    }

  }
  .tablemind:last-child{
    border-bottom: none;
  }
  .sq {
    display: inline-block;
    width: 80px;
    margin-left: 10px;
    text-align: center;
    line-height: 28px;
    color: #ffffff;
    height: 28px;
    background: #377CF1;
    cursor: pointer;
  }

  .fz28px{
    width: 100%;
    height: 40px;
    background: #F6F6F6;
    border: 1px solid #E2E2E2;
    opacity: 1;
    border-radius: 0px;
    line-height: 40px;
    padding-left:25px;
    font-weight: 700;
  }
  .mt10{
    margin-top: 10px;
  }
  .mb5{
    margin-bottom: 5px;
  }
  .mt10b{
    margin-top: 10px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e2e2e2;
  }
  // img {
  //   vertical-align: top;
  // }
  .imgs{
    width: 82px;
    img{
      width: 100%;
      height: 100%;
      margin-left: 0px;

    }
  }
  .ycj {
    display: inline-block;
    line-height: 16px;
      height: 16px;
      font-size: 12px;
      background-color: #47c460;
      color: #ffffff;
      display: inline-block;
      margin-right: 4px;
      padding:0 5px ;
  }
  .basicDev {
    padding: 0 10px;
    display: flex;
    width: 100%;
    height:195px;
    border: 1px solid #E2E2E2;
    // border-right: none;
    position: relative;
    .basicDevFlex{
      flex: 1;
      width:400px;
      height:195px;
      div{
        // padding-left: 5px;
        // padding-right: 5px;
        margin-top: 20px;
        .spanName{
          font-weight: 700;
          font-size: 14px;

        }
      }
    }
  }

  .toolDev{
    padding: 0 !important;
    .divName{
      position: absolute;
      top: 40px;
      height: 20px;
      right: 20px;
      left: 750px;
    }
    .divNames{
      position: absolute;
      top: 83px;
      left: 750px;
    }
    // width: 300px;
    // display: flex;
    // margin: 0 !important;
    // padding: 0 !important;
    // text-overflow: ellipsis;
    // -webkit-line-clamp: 1;
    // display: -webkit-box;
    //   .spanName{
    //     flex: 3;
    //     padding-right: 0 !important;
    //     height: 100%;
    //   }
    //   .divName::after{
    //     content: "...";
    //   }
    //   .divName{
    //     flex: 12;
    //     margin: 0 !important;
    //     padding: 0 !important;
    //       div{
    //         height: 100%;
    //         padding-left: 0 !important;
    //       }
    //   }

  }
  // .productTableHeader{
  //   width:1200px;
  //   height:40px;
  //   background-color:rgb(248, 248, 249);
  //   border: 1px solid #E2E2E2;
  //   div{
  //     text-align: center;
  //     line-height: 40px;
  //     font-size: 14px;
  //     font-weight: 700;
  //     height: 100%;
  //     display: inline-block;
  //   }
  // }
  // .productTableBody{
  //   border: 1px solid #E2E2E2;
  //   border-top: none;
  //   .divSG{
  //     display: inline-block;
  //     box-sizing: border-box;
  //     height: 100%;
  //     text-align: center;
  //     .iconfont{
  //       margin: 0 5px;
  //     }
  //   }
  // }
  .a{
    display: inline-block;
  }

}
  .refundHeader {
  padding-bottom: 15px;
  border-bottom: 2px solid #377cf1;
  margin-top: 90px;
  .header {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    h2 {
      height: 40px;
      font-size: 20px;
      font-weight: 600;
      color: #555555;
      padding-top: 15px;
      padding-left: 34px;
    }
  }
}
.route{
  display: inline-block;
  color: #fff;
  background-color: #377CF1;
  padding: 0px 10px;
  border-radius: 4px;
  height: 32px;
  line-height: 32px;
}
</style>
